<template>
  <van-popup
    v-model="showInvoiceHelp"
    round
    position="bottom"
    :close-on-click-overlay="false"
  >
    <div class="model">
      <div class="innerBox">
        <div class="topInfo">
          <div class="topTitle">开票帮助</div>
          <div class="closeBtn" @click="handleShowHelpInfo()"></div>
        </div>
        <div class="textInfo" v-if="cityCode === '010'">
          <div v-for="(item, index) in helpInfo1" :key="index">{{ item }}</div>
        </div>
        <div class="textInfo" v-else>
          <div v-for="(item, index) in helpInfo2" :key="index">{{ item }}</div>
        </div>
        <div class="submitBtn" @click="handleShowHelpInfo()">我知道啦</div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      helpInfo1: [
        "1.为响应国家推行电子发票的号召并确保发票开具时效，您在学而思1对1可申请开具电子发票。电子发票支持入账报销，其法律效力、基本用途及使用规定与增值税普通纸质发票一致。",
        "2.报班学习是个人行为，如开具公司抬头的发票报销使用，税务局系统能检验贵公司是否为该笔学费代缴个税，因此建议开具个人抬头发票。",
        "3.电子发票预计在24小时内推送至您的邮箱。",
        "4.您可选择的发票项目根据本地财税政策规定而定。",
        "5.您消费的各种形式的折扣优惠券不支持开票。",
      ],
      helpInfo2: [
        "1. 为响应国家推行电子发票的号召并确保发票开具时效，您在学而思1对1可申请开具电子发票。电子发票支持入账报销，其法律效力、基本用途及使用规定与增值税普通纸质发票一致。",
        "2. 电子发票预计在24小时内推送至您的邮箱。",
        "3. 您可开具的发票项目根据本地财税政策规定而定。",
        "4. 您消费的各种形式的折扣优惠券不支持开票。",
      ],
    };
  },
  computed: {
    ...mapState("invoiceApply", ["showInvoiceHelp", "cityCode"]),
  },
  mounted() {
    console.log(this.cityCode, "8989");
  },
  methods: {
    ...mapMutations("invoiceApply", ["handleShowInvoiceHelp"]),
    handleShowHelpInfo() {
      this.handleShowInvoiceHelp(false);
    },
  },
};
</script>

<style lang="scss" scoped>
.model {
  width: 100%;
  height: 100%;
  font-family: PingFangSC-Regular, PingFang SC;
  .innerBox {
    padding: 0 0 5px;
    .topInfo {
      height: 62px;
      background: #ffffff;
      font-size: 16px;
      font-weight: 500;
      color: #212832;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      width: 100%;
      .closeBtn {
        display: inline-block;
        width: 22px;
        height: 22px;
        background: url("~@/assets/img/issueInvoice/close_grey_icon@2x.png")
          no-repeat 0 0;
        background-size: contain;
        position: absolute;
        top: 50%;
        transform: translateY(-47%);
        right: 10px;
      }
    }
    .textInfo {
      padding: 0 18px;
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #212832;
      line-height: 24px;
    }
  }
  .submitBtn {
    margin: 20px 18px;
    width: 343px;
    height: 44px;
    background: #e02727;
    border-radius: 22px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
  }
}
</style>
